module.exports = __webpack_public_path__ + "media/images/icons/changelog-8bd414ae703733aaf6438cb6904afe39.svg";